module.exports = __webpack_public_path__ + "img/img (34).80b37260.jpg";